<template>
  <v-textarea
    :data-testid="toKebabCase(field.label)"
    single-line
    variant="outlined"
    hide-details="auto"
    :class="{ required: field.required }"
    :required="field.required"
    v-model="value"
    v-bind="{ ...$props, ...$attrs }"
    :prepend-icon="fieldIcon"
    :label="field.label"
    :placeholder="field.placeholder ?? field.label"
    :persistent-placeholder="Boolean(field.placeholder)"
    :rules="validationRules"></v-textarea>
</template>

<script>
import customFieldTypeMixin from '@/modules/custom_fields/mixins/customFieldTypeMixin';
import { toKebabCase } from '@nova/core';

export default {
  methods: { toKebabCase },
  name: 'custom-field-bigstring',
  mixins: [customFieldTypeMixin]
};
</script>
